import React from 'react'

import { TransportCardsProps } from './transport-cards.d';

import TransportCards from '/react4xp/components/TransportCards';

function TransportCardsPart(props: TransportCardsProps) {
    return <TransportCards {...props} />
}

export default (props) => <TransportCardsPart {...props} />
